import React from 'react';
import styles from './Badge.module.css';

/**
 * Badge Component
 * Variants: primary, success, warning, error, neutral
 * Sizes: sm, md, lg
 */
const Badge = ({
    children,
    variant = 'neutral',
    size = 'md',
    className = '',
    ...props
}) => {
    const classNames = [
        styles.badge,
        styles[variant],
        styles[size],
        className
    ].filter(Boolean).join(' ');

    return (
        <span className={classNames} {...props}>
            {children}
        </span>
    );
};

export default Badge;
